import palette from './palette'
import spacing from './spacing'
import typography from './typography'

export default {
  mainStar: {
    color: palette.primary,
    backgroundColor: palette.mainStar,
    fontSize: typography.starFontSize,
    textAlign: 'center',
  },
  mainDesc: {
    color: palette.mainStar,
    fontSize: typography.starFontSize,
  },
  auxStar: {
    color: palette.auxStar,
    fontSize: typography.starFontSize,
    textAlign: 'center',
  },
  auxDesc: {
    color: palette.mainStar,
    fontSize: typography.starFontSize,
  },
  minorStar: {
    color: palette.text.comment,
    fontSize: typography.minorStarFontSize,
    textAlign: 'center',
  },
  palette,
  typography,
  spacing,
}
